import { Button } from 'blaze-ui/Button'
import { VisuallyHidden } from '@react-aria/visually-hidden'
import { useImportMediaFiles } from 'hooks/useImportMediaFiles'
import { useUploadsProject } from 'hooks/useUploadsProject'
import { useQueryClient } from 'react-query'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { Upload5 } from 'blaze-ui/icons'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { filesKeys } from 'hooks/queries/files/filesKeys'

export const UploadButton = ({ label = 'Upload', ...buttonProps }: ButtonProps & { label?: string }) => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()
  const uploadsProjectQuery = useUploadsProject(workspaceId)
  const uploadsProjectId = uploadsProjectQuery.data?.project?.id

  const { fileInputRef, uploadImagesFromEvent, selectInput, isUploading } = useImportMediaFiles(false, () => {
    queryClient.invalidateQueries(filesKeys.partialUploadsInfinite(workspaceId))
  })

  const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    if (!uploadsProjectId) return
    uploadImagesFromEvent(event, uploadsProjectId)
  }

  return (
    <>
      <VisuallyHidden>
        <input
          aria-label="Upload images"
          ref={fileInputRef}
          type="file"
          multiple
          onChange={handleOnChange}
          accept="image/*"
        />
      </VisuallyHidden>
      <Button
        fullWidth
        size="md"
        frontIcon={Upload5}
        onPress={selectInput}
        isDisabled={isUploading || !uploadsProjectId}
        aria-label="Upload Files"
        {...buttonProps}
      >
        {isUploading ? 'Uploading...' : label}
      </Button>
    </>
  )
}
